import { getHospitalJourneyByAccessKey } from '../../../src/data/hospitalJourneys.js';

// Trust-specific starter templates. Keep these out of the nationally governed
// configurableJourneyLibrary: the existing clinical-source receipt remains unchanged.
export const NHNN_STUDIO_STARTERS = Object.freeze([
  {
    id: 'nhnn-surgery-operation',
    title: 'NHNN · Neurosurgery / Operation',
    summary: 'Existing private Queen Square surgery Journey for adaptation to complex spine surgery.',
    category: 'nhnn_pilot',
    accessKey: 'nhnn-surg-4R8N2C6T',
    route: '/j/nhnn-surg-4R8N2C6T',
    trustId: 'nhnn_uclh',
  },
  {
    id: 'nhnn-discharge-recovery',
    title: 'NHNN · Discharge and Recovery',
    summary: 'Existing private NHNN discharge and rehabilitation Journey.',
    category: 'nhnn_pilot',
    accessKey: 'nhnn-dis-6F2W8R4N',
    route: '/j/nhnn-dis-6F2W8R4N',
    trustId: 'nhnn_uclh',
  },
]);

const lookup = new Map(NHNN_STUDIO_STARTERS.map(item => [item.id, item]));

export function getNHNNStudioStarter(id) {
  return lookup.get(id) || null;
}
export function createNHNNStudioStarterJourney(id) {
  const template = getNHNNStudioStarter(id);
  const original = template && getHospitalJourneyByAccessKey(template.accessKey);
  if (!original || original.id !== id) return null;
  // Preserve original authored detail, questions, local UCLH links and draft status.
  return structuredClone(original);
}
